import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
    ShowMoreAvatarsComponent,
} from '@monsido/modules/report-center/components/show-more-avatars/show-more-avatars.component';
import { SharedModule } from '../../../../shared/shared.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { MonAvatarComponent } from '@client/app/shared/mon-avatar/mon-avatar.component';
import { NgbTooltipMfeModule } from '@client/mfe/overlay/ngb-tooltip-mfe.module';


@NgModule({
    declarations: [
        ShowMoreAvatarsComponent,
    ],
    imports: [
        CommonModule,
        NgbTooltipMfeModule,
        MonAvatarComponent,
        SharedModule,
        TranslateModule,
    ],
    exports: [
        ShowMoreAvatarsComponent,
    ],
})
export class ShowMoreAvatarsModule { }
